import { useSignIn } from "@clerk/clerk-react";
import TextInput from "Components/TextInput/TextInput";
import { Button } from "Components/ui/button";
import React, { useState } from "react";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import OTPInput from "react-otp-input";

function ForgetPassword() {
  const [step, setStep] = useState(1);
  const [data, setData] = useState({});

  const { signIn, setActive } = useSignIn();
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleCreate = async () => {
    setLoading(true);
    await signIn
      ?.create({
        strategy: "reset_password_email_code",
        identifier: data?.email,
      })
      .then((_) => {
        setLoading(false);
        setStep(2);
      })
      .catch((err) => {
        toast.error(err.errors[0].longMessage, {
          autoClose: 2000,
          className: "bg-red-opacity text-red",
        });
        setLoading(false);
      });
  };

  const handleReset = async () => {
    setLoading(true);
    await signIn
      ?.attemptFirstFactor({
        strategy: "reset_password_email_code",
        code: data?.code,
        password: data?.password,
      })
      .then((result) => {
        setActive({ session: result.createdSessionId });
        navigate("/");
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err.errors[0].longMessage, {
          autoClose: 2000,
          className: "bg-red-opacity text-red",
        });
        setLoading(false);
      });
  };

  return step == 1 ? (
    <motion.form
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: "auto" }}
      exit={{ opacity: 0, height: 0 }}
      className="flex flex-col gap-6 overflow-hidden"
      onSubmit={(e) => {
        e.preventDefault();
        handleCreate();
      }}
    >
      <TextInput
        label="Email"
        required={true}
        placeholder="Enter your email"
        type="email"
        value={data.email}
        onChange={(e) => setData({ ...data, email: e.target.value })}
      />
      <Button disabled={loading} type="submit" className="p-[1.3rem] w-full">
        {loading ? "Processing..." : "Send Reset Code"}
      </Button>
    </motion.form>
  ) : (
    <motion.form
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: "auto" }}
      exit={{ opacity: 0, height: 0 }}
      className="flex flex-col gap-6 overflow-hidden"
      onSubmit={(e) => {
        e.preventDefault();
        handleReset();
      }}
    >
      <div className="-mb-3">Enter the 6-digit code sent to your email</div>
      <div className="px-1">
        <OTPInput
          value={data?.code}
          onChange={(d) => {
            setData({ ...data, code: d });
          }}
          numInputs={6}
          renderInput={(props) => <input {...props} />}
          containerStyle={{
            justifyContent: "space-between",
            gap: "1rem",
          }}
          inputStyle={{
            width: "20%",
            aspectRatio: "1/1",
            height: "auto",
            fontSize: "1.5rem",
            borderRadius: "1rem",
            border: "1px solid var(--grey)",
            background: "transparent",
          }}
          shouldAutoFocus
        />
      </div>
      <TextInput
        label="New Password"
        required={true}
        placeholder="Enter your Password"
        type="password"
        value={data.password}
        onChange={(e) => setData({ ...data, password: e.target.value })}
      />
      <TextInput
        label="Confirm Password"
        required={true}
        placeholder="Enter your Password again"
        type="password"
        value={data.confirm}
        onChange={(e) => setData({ ...data, confirm: e.target.value })}
      />
      <Button
        disabled={loading || data?.confirm !== data?.password}
        type="submit"
        className="p-[1.3rem] w-full"
      >
        {loading ? "Processing..." : "Reset Password"}
      </Button>
    </motion.form>
  );
}

export default ForgetPassword;
